import React, { useLayoutEffect, useState } from "react";
import Moment from "react-moment";

const EventExcerptTitlePage = ({ event_object }) => {
	const [startDateTime, setStartDateTime] = useState(null),
		[startTime, setStartTime] = useState(null);

	useLayoutEffect(() => {
		let subscribed = true;
		if (subscribed) {
			const tempDateTime = event_object.start_date.replace("Z", "");
			setStartDateTime(tempDateTime);
			const hours =
				event_object.start_time.split(":")[0] +
				":" +
				event_object.start_time.split(":")[1];
			const hoursFormatted = tConvert(hours);
			setStartTime(hoursFormatted);
		}
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [event_object]);

	const tConvert = (time) => {
		time = time
			.toString()
			.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

		if (time.length > 1) {
			time = time.slice(1);
			time[5] = +time[0] < 12 ? " AM" : " PM";
			time[0] = +time[0] % 12 || 12;
		}
		return time.join("");
	};

	return (
		<>
			{event_object ? (
				<div className="col-12 col-md-6 mb-4">
					<a href={"/events/" + event_object.slug}>
						<div className="titledetail__event--date d-flex align-items-center justify-content-center">
							<div
								style={{
									backgroundColor: "rgba(255,255,255, 0.05)",
								}}
								className="col-3 p-3 d-flex flex-column align-items-center justify-content-center"
							>
								<div className="titledetail__event--date-day">
									<Moment format="dddd">
										{startDateTime}
									</Moment>
								</div>
								<div className="titledetail__event--date-number">
									<Moment format="DD">{startDateTime}</Moment>
								</div>
								<div className="titledetail__event--date-month">
									<Moment format="MMM">
										{startDateTime}
									</Moment>
								</div>
							</div>

							<div className="px-3 col-9">
								<div
									className="d-block text-white mb-2"
									style={{fontSize: "1.3rem", lineHeight:"1.25em"}}
								>
									{event_object.title}
								</div>
								<div
									className="d-block text-white mb-2"
									style={{fontSize: ".85rem", opacity:".65"}}
								>
									{startTime} {event_object.venue_timezone} @ {event_object.venue_name}
								</div>
							</div>
						</div>
					</a>
				</div>
			) : (
				""
			)}
		</>
	);
};

export default EventExcerptTitlePage;
